import React from 'react';
import DOMPurify from 'dompurify';
import {connect} from 'react-redux';
import {Header, Segment} from 'semantic-ui-react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';

/*
Renders contents as a single linear page
*/

export class Instructions extends React.Component {
  sanitizeHtml = (html) => {
    return DOMPurify.sanitize(html);
  };

  render() {
    const {title, information, html, htmlDunsToUEI, id} = this.props;

    if (htmlDunsToUEI && this.props.toggles.includes('dunsToUEI')) {
      return (
        <React.Fragment>
          <Header as="h1" id={id}>
            {title}
          </Header>
          {htmlDunsToUEI &&
            htmlDunsToUEI.map((info, index) => {
              return (
                <Segment
                  vertical
                  basic
                  dangerouslySetInnerHTML={{__html: this.sanitizeHtml(info)}}
                  key={index}
                />
              );
            })}
        </React.Fragment>
      );
    } else if (html) {
      return (
        <React.Fragment>
          <Header as="h1" id={id}>
            {title}
          </Header>
          {html &&
            html.map((info, index) => {
              return (
                <Segment
                  vertical
                  basic
                  dangerouslySetInnerHTML={{__html: this.sanitizeHtml(info)}}
                  key={index}
                />
              );
            })}
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <Header as="h1" id={id}>
            {title}
          </Header>
          {information &&
            information.map((info, index) => {
              return (
                <p className="leadParagraph" key={index}>
                  {info}
                </p>
              );
            })}
        </React.Fragment>
      );
    }
  }
}

export const mapStateToProps = (state) => {
  return {
    toggles: state.toggles.toggles,
  };
};

export default connect(mapStateToProps)(connectDynamic(Instructions));
